export const FETCH_ER_UNITS_REQUEST = "FETCH_ER_UNITS_REQUEST";
export const FETCH_ER_UNITS_SUCCESS = "FETCH_ER_UNITS_SUCCESS";
export const FETCH_ER_UNITS_FAILURE = "FETCH_ER_UNITS_FAILURE";

export const FETCH_ER_FAB_TYPES_REQUEST = "FETCH_ER_FAB_TYPES_REQUEST";
export const FETCH_ER_FAB_TYPES_SUCCESS = "FETCH_ER_FAB_TYPES_SUCCESS";
export const FETCH_ER_FAB_TYPES_FAILURE = "FETCH_ER_FAB_TYPES_FAILURE";

export const FETCH_ER_WEIGHTS_REQUEST = "FETCH_ER_WEIGHTS_REQUEST";
export const FETCH_ER_WEIGHTS_SUCCESS = "FETCH_ER_WEIGHTS_SUCCESS";
export const FETCH_ER_WEIGHTS_FAILURE = "FETCH_ER_WEIGHTS_FAILURE";

export const FETCH_ER_UNIT_FABRICATIONS_REQUEST = "FETCH_ER_UNIT_FABRICATIONS_REQUEST";
export const FETCH_ER_UNIT_FABRICATIONS_SUCCESS = "FETCH_ER_UNIT_FABRICATIONS_SUCCESS";
export const FETCH_ER_UNIT_FABRICATIONS_FAILURE = "FETCH_ER_UNIT_FABRICATIONS_FAILURE";

export const SAVE_ER_TARGET_DATES_REQUEST = "SAVE_ER_TARGET_DATES_REQUEST";
export const SAVE_ER_TARGET_DATES_SUCCESS = "SAVE_ER_TARGET_DATES_SUCCESS";
export const SAVE_ER_TARGET_DATES_FAILURE = "SAVE_ER_TARGET_DATES_FAILURE";

export const FETCH_ER_DELAY_REASONS_REQUEST = "FETCH_ER_DELAY_REASONS_REQUEST";
export const FETCH_ER_DELAY_REASONS_SUCCESS = "FETCH_ER_DELAY_REASONS_SUCCESS";
export const FETCH_ER_DELAY_REASONS_FAILURE = "FETCH_ER_DELAY_REASONS_FAILURE";

export const FETCH_ER_DAILY_REMARKS_REQUEST = "FETCH_ER_DAILY_REMARKS_REQUEST";
export const FETCH_ER_DAILY_REMARKS_SUCCESS = "FETCH_ER_DAILY_REMARKS_SUCCESS";
export const FETCH_ER_DAILY_REMARKS_FAILURE = "FETCH_ER_DAILY_REMARKS_FAILURE";

export const SAVE_ER_DAILY_REMARK_REQUEST = "SAVE_ER_DAILY_REMARK_REQUEST";
export const SAVE_ER_DAILY_REMARK_SUCCESS = "SAVE_ER_DAILY_REMARK_SUCCESS";
export const SAVE_ER_DAILY_REMARK_FAILURE = "SAVE_ER_DAILY_REMARK_FAILURE";

export const FETCH_ER_REMARK_HISTORY_REQUEST = "FETCH_ER_REMARK_HISTORY_REQUEST";
export const FETCH_ER_REMARK_HISTORY_SUCCESS = "FETCH_ER_REMARK_HISTORY_SUCCESS";
export const FETCH_ER_REMARK_HISTORY_FAILURE = "FETCH_ER_REMARK_HISTORY_FAILURE";